import React, { useState, useEffect } from 'react';
import Header from './Header';
import SideNav from './SideNav';

const Layout = ({ children }) => {
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isSideNavCollapsed, setIsSideNavCollapsed] = useState(false);
  
  // Initialize collapsed state from localStorage
  useEffect(() => {
    const savedState = localStorage.getItem('sideNavCollapsed');
    if (savedState !== null) {
      setIsSideNavCollapsed(savedState === 'true');
    }
  }, []);

  // Check if we're on mobile and update state
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkIfMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  useEffect(() => {
    const shouldLockScroll = isMobile && isSideNavOpen;
    document.body.classList.toggle('overflow-hidden', shouldLockScroll);

    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [isMobile, isSideNavOpen]);

  // Toggle side navigation
  const toggleSideNav = () => {
    setIsSideNavOpen(!isSideNavOpen);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header onMenuClick={toggleSideNav} isMenuOpen={isSideNavOpen} />
      <SideNav
        isOpen={isSideNavOpen}
        onToggle={setIsSideNavOpen}
        onCollapseChange={setIsSideNavCollapsed}
      />
      <div
        className={`pt-14 sm:pt-16 transition-all duration-300 ${isMobile ? '' : (isSideNavCollapsed ? 'md:pl-16' : 'md:pl-64')}`}
      >
        {children}
      </div>
    </div>
  );
};

export default Layout;